// N-5 (audit 26-06-09 DECISIONS 3.4, locked 2026-06-11) — "paint-then-
// correct" cache policy for the per-image overlay queries (the findings +
// defects queries scoped by `imageId` that feed the Viewer overlay and the
// List/Tiles "Current image" surfaces):
//
//   * `staleTime: 15_000` — a copy warmed by the overlay prefetcher
//     (PERF-06) or by a recent visit paints instantly on mount, and the
//     prefetcher itself never refires for a window entry that is already
//     warm;
//   * `refetchOnMount: "always"` — every mount still revalidates in the
//     background, so a warm-but-stale copy corrects itself within ~RTT
//     (TanStack keeps showing the cached payload while the refetch runs).
//
// Both the mount policy (useFindingsQuery / useDefectsQuery) and the
// prefetch policy (useOverlayPrefetch) read THIS constant so the two can
// never drift apart.
export const OVERLAY_STALE_TIME_MS = 15_000;
